module.exports = __webpack_public_path__ + "static/media/6630.273d1195.jpg";